import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? match[1] : null;
    (async () => {
      if (!session_id) { nav("/admin"); return; }
      try {
        window.history.replaceState({}, "", "/admin/dashboard");
        const res = await exchangeSession(session_id);
        if (res?.user?.is_admin || res?.user?.email) {
          nav("/admin/dashboard", { state: { user: res.user } });
        } else {
          toast.error("Not authorized");
          nav("/admin");
        }
      } catch (e) {
        toast.error("Sign in failed");
        nav("/admin");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#06080F] text-white flex items-center justify-center">
      <div className="chip"><span className="pulse-dot"/> Signing you in…</div>
    </div>
  );
}
